<template>
  <div>
    <el-input
      v-if="obj.controlName === 'text'"
      v-model="obj.value"
      :placeholder="obj.placeholder"
      :disabled="obj.disabled"
    />
    <el-radio-group v-else-if="obj.controlName === 'radio'" v-model="obj.value" :disabled="obj.disabled">
      <el-radio
        v-for="index in obj.option"
        :key="index"
        :label="index"
        :value="index"
      />
    </el-radio-group>
    <el-select v-else-if="obj.controlName === 'select'" v-model="obj.value" :disabled="obj.disabled">
      <el-option
        v-for="index in obj.option"
        :key="index"
        :label="index"
        :value="index"
      />
    </el-select>
    <el-checkbox-group v-else-if="obj.controlName === 'checkbox'" v-model="obj.value" @change="updateView">
      <el-checkbox
        v-for="(name, index) in obj.option"
        :key="index"
        :label="name"
      />
    </el-checkbox-group>
    <el-date-picker
      v-else-if="obj.controlName === 'date'"
      v-model="obj.value"
      value-format="yyyy-MM-dd"
      type="date"
      placeholder="选择日期"
    />
    <el-input
      v-else-if="obj.controlName === 'textarea'"
      type="textarea"
      :rows="3"
      placeholder="请输入内容"
      v-model="obj.value"
    />
    <template v-else-if="obj.controlName === 'table'">
      <el-table
        :data="obj.value"
        border
        style="width: 100%">
        <el-table-column
          v-for="(name, index) in obj.tableHead"
          :key="index"
          :label="name"
        >
          <template slot-scope="scope">
            <el-input v-if="index !== obj.tableHead.length - 1" v-model="scope.row[index]" />
            <el-button v-else type="text" @click="removeColumn(scope.$index)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <el-button @click="addColumn" size="small">添加</el-button>
      </div>
    </template>

    <template v-else-if="obj.controlName === 'file'">
      <photo-upload v-if="obj.fieldName === 'zjzzp'" :data="obj.value" @file="getFile" @uploadSuccess="uploadSuccess" />
      <single-upload v-else :data="obj.value" @file="getFile" @uploadSuccess="uploadSuccess" />
    </template>
    <template v-else-if="obj.controlName === 'files'">
      <multiple-upload @file="getFiles" @uploadMultipleSuccess="uploadMultipleSuccess" />
    </template>
  </div>
</template>

<script>
import SingleUpload from './SingleUpload'
import MultipleUpload from './MultipleUpload'
import PhotoUpload from './PhotoUpload'
export default {
  name: 'FormItem',
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    SingleUpload,
    MultipleUpload,
    PhotoUpload
  },
  data() {
    return {
      objItem: {}
    }
  },
  created() {
    this.objItem = Object.assign({}, this.obj)
    const optionType = ['radio', 'select']
    if (optionType.indexOf(this.obj.controlName) !== -1) {
      this.obj.option = this.obj.options.split('|')
    } else if (this.obj.controlName === 'checkbox') {
      this.obj.option = this.obj.options.split('|')
      this.obj.value = []
    } else if (this.obj.controlName === 'table') {
      this.obj.tableHead = this.obj.options.split('|')
      this.obj.tableHead.push('操作')
      if (this.obj.value) {
        this.obj.value = JSON.parse(this.obj.value)
      } else {
        this.obj.value = []
        let arr = []
        for(let i = 0; i < this.obj.tableHead.length - 1; i++) {
          arr.push('')
        }
        this.obj.value.push(arr)
      }
    }
    if (this.obj.fieldName === 'xingming') {
      if (this.$store.state.user.userInfo.realName) {
        this.obj.value = this.$store.state.user.userInfo.realName
        this.obj.disabled = true
      }
    } else if (this.obj.fieldName === 'sfz') {
      if (this.$store.state.user.userInfo.idCardNo) {
        this.obj.value = this.$store.state.user.userInfo.idCardNo
        this.obj.disabled = true
      }
    } else if (this.obj.fieldName === 'sjh') {
      if (this.$store.state.user.userInfo.phone) {
        this.obj.value = this.$store.state.user.userInfo.phone
        this.obj.disabled = true
      }
    } else if (this.obj.fieldName === 'xb') {
      if (this.$store.state.user.userInfo.gender) {
        this.obj.value = this.$store.state.user.userInfo.gender
        this.obj.disabled = true
      }
    } else if (this.obj.fieldName === 'csrq') {
      if (this.$store.state.user.userInfo.birth) {
        this.obj.value = this.$store.state.user.userInfo.birth
        this.obj.disabled = true
      }
    }
    this.$forceUpdate()
  },
  methods: {
    addColumn() {
      let arr = []
      for(let i = 0; i < this.obj.tableHead.length - 1; i++) {
        arr.push('')
      }
      this.obj.value.push(arr)
    },
    removeColumn(index) {
      this.obj.value.splice(index, 1)
      this.$forceUpdate()
    },
    updateView() {
      this.$forceUpdate()
    },
    getFile(file) {
      console.log(file)
    },
    getFiles(files) {
      console.log(files)
    },
    uploadSuccess(id) {
      this.obj.value = id
    },
    uploadMultipleSuccess(arr) {
      this.obj.value = arr
    }
  }
}
</script>
